export default class Select {
  text!: string;
  value!: number | string;
}
